export default __webpack_public_path__ + "static/media/ProfilePic.50521dc8.png";